import { render, staticRenderFns } from "./DadosAluno.vue?vue&type=template&id=7397cc50&"
import script from "./DadosAluno.vue?vue&type=script&lang=js&"
export * from "./DadosAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports